import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ConfiguracaoFinanceiraGeralRequest } from '../../requests/financas/configuracao-financeira-geral.request';
import { ConfiguracaoFinanceiraGeralResponse } from '../../responses/financas/configuracao-financeira-geral.response';
import { ConfiguracaoFinanceiraGeralLookupsResponse } from '../../responses/financas/configuracao-financeira-geral-lookups.response';
import { ReturnStruct } from '../../structs/return.struct';
import { CommonService } from '../../common-service';

@Injectable({
    providedIn: 'root'
})
export class ConfiguracaoFinanceiraGeralService extends CommonService {
    private apiUrl = `${environment.urlApiFinancas}ConfiguracaoFinanceiraGeral`;

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getConfiguracao(): Observable<ConfiguracaoFinanceiraGeralResponse> {
        return this.httpClient
            .get<ConfiguracaoFinanceiraGeralResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }


    public getLookups(): Observable<ConfiguracaoFinanceiraGeralLookupsResponse> {
        return this.httpClient
            .get<ConfiguracaoFinanceiraGeralLookupsResponse>(`${this.apiUrl}/Lookups`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }


    public updateConfiguracao(request: ConfiguracaoFinanceiraGeralRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}`;
        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
